import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import {
  TextInput,
  DateInput,
  CustomSwitch,
  IntInput,
} from "components/Input/Index.js";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { memberorder } from "variables/markets";
import {
  memberorderTypeData,
  memberorderElectricitySegment,
  memberorderElectricityTurpeVersionC5,
  memberorderElectricityTurpeVersionC4C3C2,
  memberorderElectricityTurpeVersionC5Ecl,
  memberorderElectricityEclHourCount,
  memberorderElectricityRenewableMix,
  memberorderGasProfil,
  memberorderGasTariff
} from "variables/lists/markets";
import { postMarketMembershipOrder, getMarketMemberships, getMarketMeters } from "services/ConfigServices";
import { MarketsContext } from "context/MarketsContext";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import LocalizationAutocomplete from "components/LocalizationAutocomplete/LocalizationAutocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "97%",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "97%",
  },
}));


const Subsectiontitle = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
font-family: "Source Sans Pro", sans-serif;
margin-top: 15px;
`;

function CreateServiceOrderDialog(props) {
  const { closeModal, refetch } = props;
  const appContext = useContext(MarketsContext);
  const { market } = appContext;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = advancedSearchContext;

  const [membershipsOptions, setMembershipsOptions] = useState([]);
  const [memberships, setMemberships] = useState([]);
  const [membership, setMembership] = useState("");
  const [membershipGroup, setMembershipGroup] = useState("");

  const [ordertype, setOrdertype] = useState("");
  const [marketmembershipid, setMarketmembershipid] = useState("");
  const [marketmembershipname, setMarketmembershipname] = useState("");
  const [marketmembershipnumber, setMarketmembershipnumber] = useState("");
  const [marketmembershipaddress, setMarketmembershipaddress] = useState("");
  const [marketmembershipsiret, setMarketmembershipsiret] = useState("");
  const [referentname, setReferentname] = useState("");
  const [referentemail, setReferentemail] = useState("");
  const [referentphone, setReferentphone] = useState("");

  const [membershipMeters, setMembershipMeters] = useState([]);
  const [meter, setMeter] = useState({});
  const [pdl, setPdl] = useState("");
  const [pdlusagecode, setPdlusagecode] = useState("");
  const [pdladdress, setPdladdress] = useState("");
  const [pdlinseecode, setPdlinseecode] = useState("");
  const [pdlreferenceconsumption, setPdlreferenceconsumption] = useState("");
  const [pdldropmeter, setPdldropmeter] = useState("");
  const [pdlname, setPdlname] = useState("");
  const [pdloldname, setPdloldname] = useState("");
  const [pdloldaddress, setPdloldaddress] = useState("");
  const [pdloldusagecode, setPdloldusagecode] = useState("");
  const [pdlcontractualdata, setPdlcontractualdata] = useState({});
  const [pdloldcontractualdata, setPdloldcontractualdata] = useState({});

  const [comments, setComments] = useState("");
  const [startdate, setStartdate] = useState("");
  const [enddate, setEnddate] = useState("");
  const [renewablemix, setRenewablemix] = useState("");
  const [billregroupname, setBillregroupname] = useState("");
  const [billregroupcode, setBillregroupcode] = useState("");
  const [billbudgetcode, setBillbudgetcode] = useState("");

  const [localizationValue, setLocalizationValue] = useState("");
  const [options, setOptions] = useState([]);
  const [validatedAddress, setValidatedAddress] = useState({});
  const [pdlvalidatedAddress, setPdlvalidatedAddress] = useState({});
  const [pdloldvalidatedAddress, setPdloldvalidatedAddress] = useState({});

  const loaded = useRef(false);

  console.log(pdladdress);

  const [groups, setGroups] = useState("");
  const [groupsParent, setGroupsParent] = useState(
    market?.parameters?.general?.groups?.[0]
  );

  const [buttonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    if (
      membership
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [membership]);


  const handleSubmit = async (event) => {
    createOrder(event);
  };

  const handleOrdertypeChange = (event) => { setOrdertype(event.target.value); };

  const handleSiretChange = (event) => { setMarketmembershipsiret(event.target.value); };
  const handleReferentnameChange = (event) => { setReferentname(event.target.value); };
  const handleReferentemailChange = (event) => { setReferentemail(event.target.value); };
  const handleReferentphoneChange = (event) => { setReferentphone(event.target.value); };
  const handlePdlChange = (event) => { setPdl(event.target.value); };
  const handlePdlAutoChange = (newValue) => {
    setMeter(newValue);
    setPdl(newValue.id);
    setPdloldaddress(newValue.address || "");
    setPdloldvalidatedAddress(newValue.validatedAddress || "");
    setPdloldusagecode(newValue.usagecode || "");
    setPdloldname(newValue.pdlname || "");
    setPdloldcontractualdata({});
    setPdlcontractualdata({});

  };
  const handlePdladdressChange = (event) => { setPdladdress(event.target.value); };
  const handlePdlinseecodeChange = (event) => { setPdlinseecode(event.target.value); };
  const handlePdlreferenceconsumptionChange = (event) => { setPdlreferenceconsumption(event.target.value); };
  const handlePdlnameChange = (event) => { setPdlname(event.target.value); };
  const handlePdloldnameChange = (event) => { setPdloldname(event.target.value); };
  const handlePdlusagecodeChange = (event) => { setPdlusagecode(event.target.value); };
  const handlePdloldusagecodeChange = (event) => { setPdloldusagecode(event.target.value); };

  const handlePdlcontractualdataChange = (event) => {
    const { name, value } = event.target;
    setPdlcontractualdata((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handlePdloldcontractualdataChange = (event) => {
    const { name, value } = event.target;
    setPdloldcontractualdata((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handlePdldropmeterChange = (event) => { setPdldropmeter(!pdldropmeter); };
  const handleCommentsChange = (event) => { setComments(event.target.value); };
  const handleStartdateChange = (event) => { setStartdate(event.target.value); };
  const handleEnddateChange = (event) => { setEnddate(event.target.value); };
  const handleRenewablemixChange = (event) => { setRenewablemix(event.target.value); };
  const handleBillregroupnameChange = (event) => { setBillregroupname(event.target.value); };
  const handleBillregroupcodeChange = (event) => { setBillregroupcode(event.target.value); };
  const handleBillbudgetcodeChange = (event) => { setBillbudgetcode(event.target.value); };

  const handleMembershipChange = (newValue) => {
    setMembership(newValue);
    if (newValue) {
      let obj = memberships.find((o) => o.id === newValue.id);
      setMarketmembershipid(obj.id)
      setMembershipGroup(obj?.parameters.groups[0]);
      setMarketmembershipname(obj?.parameters.name || "");
      setMarketmembershipnumber(obj?.parameters.marketmembershipnumber || "");
      setMarketmembershipaddress(obj?.parameters.billingaddress || "");
      setMarketmembershipsiret(obj?.parameters.siret || "");
    }
    else {
      setMembershipGroup("");
    }
  };

  const selectedMembership = () => {
    let selected = {};
    if (membership !== undefined) {
      selected = membership;
    }
    return selected;
  };

  const selectedMeter = () => {
    let selected = {};
    if (meter !== undefined) {
      selected = meter;
    }
    return selected;
  };

  useEffect(() => {
    axios
      .get(
        getMarketMemberships(chartIdGroup, market.id),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let tmpMembershipsData = res.data.memberships?.map((data) => {
          return (
            { name: data.parameters.name + ' (' + data.parameters.marketmembershipnumber + ')', id: data.id }
          );
        });
        setMembershipsOptions(tmpMembershipsData || []);
        setMemberships(res.data.memberships || []);
      });

  }, []);

  useEffect(() => {
    axios
      .get(
        getMarketMeters(chartIdGroup, market.id, membership.id),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let tmpMetersData = res.data.meters?.filter((item) => item.exist).map((data) => { //filter on exist
          return (
            { ...data, name: data.meternumber, id: data.meternumber, autoid: data.id }
          );
        });
        console.log(tmpMetersData);
        setMembershipMeters(tmpMetersData || []);
      });

  }, [membership]);


  const createOrder = async (event) => {
    await axios
      .post(
        postMarketMembershipOrder(membership.id),
        {
          ordertype,
          marketmembershipid,
          marketmembershipname,
          marketmembershipaddress,
          marketmembershipsiret,
          marketmembershipnumber,
          marketmeterid: meter?.autoid || '',
          marketmeteraccountmeterid: meter?.accountmeterid || '',
          referentname,
          referentemail,
          referentphone,
          pdl,
          pdladdress,
          pdloldaddress,
          pdlinseecode,
          pdlreferenceconsumption,
          pdlname,
          pdloldname,
          pdlusagecode,
          pdloldusagecode,
          pdlcontractualdata,
          pdloldcontractualdata,
          comments,
          startdate,
          enddate,
          renewablemix,
          billregroupname,
          billregroupcode,
          billbudgetcode,
          pdldropmeter,
          creationdate: (moment().unix()) * 1000,
          status: 'membervalidation',
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Ordre de service créé");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <CustomSelect
                inputTitle={memberorder.ordertype}
                selectValue={ordertype}
                handleSelectValueChange={handleOrdertypeChange}
                data={memberorderTypeData}
              />
            </div>
            <div>
              <DateInput
                inputTitle={memberorder.executiondate}
                dateInput={startdate}
                handleDateInputChange={handleStartdateChange}
              />
            </div>
            {(ordertype === 'provis') &&
              <div>
                <DateInput
                  inputTitle={memberorder.enddate}
                  dateInput={enddate}
                  handleDateInputChange={handleEnddateChange}
                />
              </div>
            }
            {ordertype &&
              <>
                <Subsectiontitle>Membre</Subsectiontitle>
                <div>
                  <AutocompleteInputMeters
                    isRequired
                    specialWidth={"97%"}
                    inputTitle={"Choix de l'adhérent"}
                    selected={selectedMembership()}
                    list={membershipsOptions}
                    handleChange={(_, newValue) =>
                      handleMembershipChange(newValue)
                    }
                  />
                </div>
              </>
            }
            {membership &&
              <>

                <div>
                  <TextInput
                    isRequired
                    inputTitle={memberorder.marketmembershipname}
                    textInput={marketmembershipname}
                    disabled
                  />
                </div>
                <div>
                  <LocalizationAutocomplete
                    displayLatLng={false}
                    inputTitle={memberorder.marketmembershipaddress}
                    value={marketmembershipaddress}
                    setValue={setMarketmembershipaddress}
                    inputValue={localizationValue}
                    setInputValue={setLocalizationValue}
                    options={options}
                    setOptions={setOptions}
                    setValidatedAddress={setValidatedAddress}
                    validatedAddress={validatedAddress}
                    loaded={loaded}
                    specialWidth={"97%"}
                  />
                </div>
                <div>
                  <TextInput
                    isRequired
                    inputTitle={memberorder.marketmembershipsiret}
                    textInput={marketmembershipsiret}
                    handleTextInputChange={handleSiretChange}
                  />
                </div>

                <Subsectiontitle>Référent technique</Subsectiontitle>
                <div>
                  <TextInput
                    isRequired
                    inputTitle={memberorder.referentname}
                    textInput={referentname}
                    handleTextInputChange={handleReferentnameChange}
                  />
                </div>
                <div>
                  <TextInput
                    isRequired
                    inputTitle={memberorder.referentemail}
                    textInput={referentemail}
                    handleTextInputChange={handleReferentemailChange}
                  />
                </div>
                <div>
                  <TextInput
                    isRequired
                    inputTitle={memberorder.referentphone}
                    textInput={referentphone}
                    handleTextInputChange={handleReferentphoneChange}
                  />
                </div>
                {(ordertype === 'detach' || ordertype === 'change') ?
                  <>
                    <Subsectiontitle>Informations du Point de livraison à modifier</Subsectiontitle>
                    {/* <> */}
                    {/* <div>
                      <TextInput
                        isRequired
                        inputTitle={memberorder.pdl}
                        textInput={pdl}
                        handleTextInputChange={handlePdlChange}
                      />
                    </div> */}
                    {/* </> : */}
                    <div>
                      <AutocompleteInputMeters
                        isRequired
                        specialWidth={"97%"}
                        inputTitle={memberorder.pdl}
                        selected={selectedMeter()}
                        list={membershipMeters}
                        handleChange={(_, newValue) =>
                          handlePdlAutoChange(newValue)
                        }
                      />
                    </div>
                    <div>
                      <TextInput
                        inputTitle={memberorder.pdlname}
                        textInput={pdloldname}
                        handleTextInputChange={handlePdloldnameChange}
                      />
                    </div>
                    <div>
                      <LocalizationAutocomplete
                        displayLatLng={false}
                        inputTitle={memberorder.pdladdress}
                        value={pdloldaddress}
                        setValue={setPdloldaddress}
                        inputValue={localizationValue}
                        setInputValue={setLocalizationValue}
                        options={options}
                        setOptions={setOptions}
                        setValidatedAddress={setPdloldvalidatedAddress}
                        validatedAddress={pdloldvalidatedAddress}
                        loaded={loaded}
                        specialWidth={"97%"}
                        freeSolo={true}
                      />
                    </div>
                    {/* <div>
                      <TextInput
                        inputTitle={memberorder.pdlusagecode}
                        textInput={pdloldusagecode}
                        handleTextInputChange={handlePdloldusagecodeChange}
                      />
                    </div> */}
                    <div>
                      <TextInput
                        inputTitle={memberorder.pdlinseecode}
                        textInput={pdlinseecode}
                        handleTextInputChange={handlePdlinseecodeChange}
                      />
                    </div>
                  </> : <></>
                }
                {(ordertype === 'detach') ?
                  <>
                  
                    {/* redondant avec date de réalisation (start date)
                    <div>
                      <DateInput
                        inputTitle={memberorder.enddate}
                        dateInput={enddate}
                        handleDateInputChange={handleEnddateChange}
                      />
                    </div> */}
                    <div>
                      <CustomSwitch
                        inputTitle={memberorder.pdldropmeter}
                        checkedState={pdldropmeter}
                        handleSwitchChange={handlePdldropmeterChange}
                      />
                    </div>
                  </>
                  :
                  <>



                    {(ordertype === 'change') &&
                      <>
                        <Subsectiontitle>Données contractuelles actuelles</Subsectiontitle>
                        {(market?.parameters?.general?.energy === 'electricity') &&
                          <>
                            <div>
                              <CustomSelect
                                inputTitle={memberorder.electricity.pdltype}
                                selectValue={pdloldcontractualdata?.pdltype}
                                handleSelectValueChange={handlePdloldcontractualdataChange}
                                data={memberorderElectricitySegment}
                                name={"pdltype"}
                              />
                            </div>
                            <div>
                              <CustomSelect
                                inputTitle={memberorder.electricity.turpe}
                                selectValue={pdloldcontractualdata?.turpe}
                                handleSelectValueChange={handlePdloldcontractualdataChange}
                                data={pdloldcontractualdata?.pdltype === 'C5ecl' ? memberorderElectricityTurpeVersionC5Ecl :
                                  pdloldcontractualdata?.pdltype === 'C5bat' ? memberorderElectricityTurpeVersionC5 :
                                    pdloldcontractualdata?.pdltype ? memberorderElectricityTurpeVersionC4C3C2 : []}
                                name={"turpe"}
                              />
                            </div>

                            {((pdloldcontractualdata?.turpe === 'cu' && pdloldcontractualdata?.pdltype === 'C5bat') ||
                              (pdloldcontractualdata?.pdltype === 'C5ecl')) &&
                              <div>
                                <IntInput
                                  inputTitle={memberorder.electricity.psousbase}
                                  intInput={pdloldcontractualdata?.psousbase}
                                  handleIntInputChange={handlePdloldcontractualdataChange}
                                  name={"psousbase"}
                                />
                              </div>
                            }
                            {((pdloldcontractualdata?.turpe === 'mu' && pdloldcontractualdata?.pdltype === 'C5bat')) &&
                              <>
                                <div>
                                  <IntInput
                                    inputTitle={memberorder.electricity.psoushp}
                                    intInput={pdloldcontractualdata?.psoushp}
                                    handleIntInputChange={handlePdloldcontractualdataChange}
                                    name={"psoushp"}
                                  />
                                </div>
                                <div>
                                  <IntInput
                                    inputTitle={memberorder.electricity.psoushc}
                                    intInput={pdloldcontractualdata?.psoushc}
                                    handleIntInputChange={handlePdloldcontractualdataChange}
                                    name={"psoushc"}
                                  />
                                </div>
                              </>
                            }
                            {((pdloldcontractualdata?.turpe === 'lu' && pdloldcontractualdata?.pdltype === 'C5bat') ||
                              (pdloldcontractualdata?.pdltype === 'C4') || (pdloldcontractualdata?.pdltype === 'C3') || (pdloldcontractualdata?.pdltype === 'C2')) &&
                              <>
                                <div>
                                  <IntInput
                                    inputTitle={memberorder.electricity.psoushph}
                                    intInput={pdloldcontractualdata?.psoushph}
                                    handleIntInputChange={handlePdloldcontractualdataChange}
                                    name={"psoushph"}
                                  />
                                </div>
                                <div>
                                  <IntInput
                                    inputTitle={memberorder.electricity.psoushch}
                                    intInput={pdloldcontractualdata?.psoushch}
                                    handleIntInputChange={handlePdloldcontractualdataChange}
                                    name={"psoushch"}
                                  />
                                </div>
                                <div>
                                  <IntInput
                                    inputTitle={memberorder.electricity.psoushpe}
                                    intInput={pdloldcontractualdata?.psoushpe}
                                    handleIntInputChange={handlePdloldcontractualdataChange}
                                    name={"psoushpe"}
                                  />
                                </div>
                                <div>
                                  <IntInput
                                    inputTitle={memberorder.electricity.psoushce}
                                    intInput={pdloldcontractualdata?.psoushce}
                                    handleIntInputChange={handlePdloldcontractualdataChange}
                                    name={"psoushce"}
                                  />
                                </div>
                              </>
                            }
                            {((pdloldcontractualdata?.pdltype === 'C3') || (pdloldcontractualdata?.pdltype === 'C2')) &&
                              <>
                                <div>
                                  <IntInput
                                    inputTitle={memberorder.electricity.psouspointe}
                                    intInput={pdloldcontractualdata?.psouspointe}
                                    handleIntInputChange={handlePdloldcontractualdataChange}
                                    name={"psouspointe"}
                                  />
                                </div>
                              </>
                            }
                            {((pdloldcontractualdata?.pdltype === 'C5ecl')) &&
                              <>
                                <div>
                                  <CustomSelect
                                    inputTitle={memberorder.electricity.nbhour}
                                    selectValue={pdloldcontractualdata?.nbhour}
                                    handleSelectValueChange={handlePdloldcontractualdataChange}
                                    data={memberorderElectricityEclHourCount}
                                    name={"nbhour"}
                                  />
                                </div>
                              </>
                            }
                          </>
                        }
                        {(market?.parameters?.general?.energy === 'gas') &&
                          <>
                            <div>
                              <CustomSelect
                                inputTitle={memberorder.gas.profil}
                                selectValue={pdloldcontractualdata?.profil}
                                handleSelectValueChange={handlePdloldcontractualdataChange}
                                data={memberorderGasProfil}
                                name={"profil"}
                              />
                            </div>
                            <div>
                              <CustomSelect
                                inputTitle={memberorder.gas.tarif}
                                selectValue={pdloldcontractualdata?.tarif}
                                handleSelectValueChange={handlePdloldcontractualdataChange}
                                data={memberorderGasTariff}
                                name={"tarif"}
                              />
                            </div>
                          </>
                        }
                      </>
                    }
                    {(ordertype !== 'detach') &&
                      <>
                        <Subsectiontitle>Informations du Point de livraison souhaitées</Subsectiontitle>
                        {(ordertype === 'attachmeter') && <div>
                          <TextInput
                            inputTitle={memberorder.pdl}
                            textInput={pdl}
                            handleTextInputChange={handlePdlChange}
                          />
                        </div>}
                        <div>
                          <TextInput
                            inputTitle={memberorder.pdlname}
                            textInput={pdlname}
                            handleTextInputChange={handlePdlnameChange}
                          />
                        </div>
                        <div>
                          <LocalizationAutocomplete
                            displayLatLng={false}
                            inputTitle={memberorder.pdladdress}
                            value={pdladdress}
                            setValue={setPdladdress}
                            inputValue={localizationValue}
                            setInputValue={setLocalizationValue}
                            options={options}
                            setOptions={setOptions}
                            setValidatedAddress={setPdlvalidatedAddress}
                            validatedAddress={pdlvalidatedAddress}
                            loaded={loaded}
                            specialWidth={"97%"}
                            freeSolo={true}
                          />
                        </div>
                        {/* <div>
                          <TextInput
                            inputTitle={memberorder.pdlusagecode}
                            textInput={pdlusagecode}
                            handleTextInputChange={handlePdlusagecodeChange}
                          />
                        </div> */}
                        {(ordertype === 'attachmeter' || ordertype === 'provis') &&
                          <>
                            <div>
                              <TextInput
                                inputTitle={memberorder.pdlreferenceconsumption}
                                textInput={pdlreferenceconsumption}
                                handleTextInputChange={handlePdlreferenceconsumptionChange}
                              />
                            </div>
                            {(market?.parameters?.general?.energy === 'electricity') &&
                              <div>
                                <CustomSelect
                                  inputTitle={memberorder.renewablemix}
                                  selectValue={renewablemix}
                                  handleSelectValueChange={handleRenewablemixChange}
                                  data={memberorderElectricityRenewableMix}
                                />
                              </div>
                            }
                            <div>
                              <TextInput
                                inputTitle={memberorder.billregroupname}
                                textInput={billregroupname}
                                handleTextInputChange={handleBillregroupnameChange}
                              />
                            </div>
                            <div>
                              <TextInput
                                inputTitle={memberorder.billregroupcode}
                                textInput={billregroupcode}
                                handleTextInputChange={handleBillregroupcodeChange}
                              />
                            </div>
                            <div>
                              <TextInput
                                inputTitle={memberorder.billbudgetcode}
                                textInput={billbudgetcode}
                                handleTextInputChange={handleBillbudgetcodeChange}
                              />
                            </div>
                          </>
                        }
                        <Subsectiontitle>Données contractuelles souhaitées</Subsectiontitle>
                        {(market?.parameters?.general?.energy === 'electricity') &&
                          <>
                            <div>
                              <CustomSelect
                                inputTitle={memberorder.electricity.pdltype}
                                selectValue={pdlcontractualdata?.pdltype}
                                handleSelectValueChange={handlePdlcontractualdataChange}
                                data={memberorderElectricitySegment}
                                name={"pdltype"}
                              />
                            </div>
                            <div>
                              <CustomSelect
                                inputTitle={memberorder.electricity.turpe}
                                selectValue={pdlcontractualdata?.turpe}
                                handleSelectValueChange={handlePdlcontractualdataChange}
                                data={pdlcontractualdata?.pdltype === 'C5ecl' ? memberorderElectricityTurpeVersionC5Ecl :
                                  pdlcontractualdata?.pdltype === 'C5bat' ? memberorderElectricityTurpeVersionC5 :
                                    pdlcontractualdata?.pdltype ? memberorderElectricityTurpeVersionC4C3C2 : []}
                                name={"turpe"}
                              />
                            </div>

                            {((pdlcontractualdata?.turpe === 'cu' && pdlcontractualdata?.pdltype === 'C5bat') ||
                              (pdlcontractualdata?.pdltype === 'C5ecl')) &&
                              <div>
                                <IntInput
                                  inputTitle={memberorder.electricity.psousbase}
                                  intInput={pdlcontractualdata?.psousbase}
                                  handleIntInputChange={handlePdlcontractualdataChange}
                                  name={"psousbase"}
                                />
                              </div>
                            }
                            {((pdlcontractualdata?.turpe === 'mu' && pdlcontractualdata?.pdltype === 'C5bat')) &&
                              <>
                                <div>
                                  <IntInput
                                    inputTitle={memberorder.electricity.psoushp}
                                    intInput={pdlcontractualdata?.psoushp}
                                    handleIntInputChange={handlePdlcontractualdataChange}
                                    name={"psoushp"}
                                  />
                                </div>
                                <div>
                                  <IntInput
                                    inputTitle={memberorder.electricity.psoushc}
                                    intInput={pdlcontractualdata?.psoushc}
                                    handleIntInputChange={handlePdlcontractualdataChange}
                                    name={"psoushc"}
                                  />
                                </div>
                              </>
                            }
                            {((pdlcontractualdata?.turpe === 'lu' && pdlcontractualdata?.pdltype === 'C5bat') ||
                              (pdlcontractualdata?.pdltype === 'C4') || (pdlcontractualdata?.pdltype === 'C3') || (pdlcontractualdata?.pdltype === 'C2')) &&
                              <>
                                <div>
                                  <IntInput
                                    inputTitle={memberorder.electricity.psoushph}
                                    intInput={pdlcontractualdata?.psoushph}
                                    handleIntInputChange={handlePdlcontractualdataChange}
                                    name={"psoushph"}
                                  />
                                </div>
                                <div>
                                  <IntInput
                                    inputTitle={memberorder.electricity.psoushch}
                                    intInput={pdlcontractualdata?.psoushch}
                                    handleIntInputChange={handlePdlcontractualdataChange}
                                    name={"psoushch"}
                                  />
                                </div>
                                <div>
                                  <IntInput
                                    inputTitle={memberorder.electricity.psoushpe}
                                    intInput={pdlcontractualdata?.psoushpe}
                                    handleIntInputChange={handlePdlcontractualdataChange}
                                    name={"psoushpe"}
                                  />
                                </div>
                                <div>
                                  <IntInput
                                    inputTitle={memberorder.electricity.psoushce}
                                    intInput={pdlcontractualdata?.psoushce}
                                    handleIntInputChange={handlePdlcontractualdataChange}
                                    name={"psoushce"}
                                  />
                                </div>
                              </>
                            }
                            {((pdlcontractualdata?.pdltype === 'C3') || (pdlcontractualdata?.pdltype === 'C2')) &&
                              <>
                                <div>
                                  <IntInput
                                    inputTitle={memberorder.electricity.psouspointe}
                                    intInput={pdlcontractualdata?.psouspointe}
                                    handleIntInputChange={handlePdlcontractualdataChange}
                                    name={"psouspointe"}
                                  />
                                </div>
                              </>
                            }
                            {((pdlcontractualdata?.pdltype === 'C5ecl')) &&
                              <>
                                <div>
                                  <CustomSelect
                                    inputTitle={memberorder.electricity.nbhour}
                                    selectValue={pdlcontractualdata?.nbhour}
                                    handleSelectValueChange={handlePdlcontractualdataChange}
                                    data={memberorderElectricityEclHourCount}
                                    name={"nbhour"}
                                  />
                                </div>
                              </>
                            }
                          </>
                        }
                        {(market?.parameters?.general?.energy === 'gas') &&
                          <>
                            <div>
                              <CustomSelect
                                inputTitle={memberorder.gas.profil}
                                selectValue={pdlcontractualdata?.profil}
                                handleSelectValueChange={handlePdlcontractualdataChange}
                                data={memberorderGasProfil}
                                name={"profil"}
                              />
                            </div>
                            <div>
                              <CustomSelect
                                inputTitle={memberorder.gas.tarif}
                                selectValue={pdlcontractualdata?.tarif}
                                handleSelectValueChange={handlePdlcontractualdataChange}
                                data={memberorderGasTariff}
                                name={"tarif"}
                              />
                            </div>
                          </>
                        }

                      </>
                    }
                  </>
                }


                <Subsectiontitle>Autres précisions</Subsectiontitle>
                <div>
                  <TextInput
                    inputTitle={memberorder.comments}
                    textInput={comments}
                    handleTextInputChange={handleCommentsChange}
                  />
                </div>
              </>
            }

            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Créer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}

export default CreateServiceOrderDialog;
